import React from "react";
import { useTranslation } from "@coworker/locales";
import SearchBarComponentPresentation from "./SearchBarComponentPresentation";
import { FixaSearchActions } from "@coworker/apprestructured/src/shared/wrappers/FixaSearch/FixaSearch";

interface SearchBarComponentProps {
  onSearchBarClick?: () => void | undefined;
  handleSearchQueryChange?: (
    e: React.ChangeEvent<HTMLInputElement>
  ) => void | undefined;
  onSearchQueryReset?: () => void | undefined;
  searchQuery?: string | undefined;
  autoFocus?: boolean | undefined;
  onFocus?: () => void | undefined;
  onBlur?: () => void | undefined;
  actions?: FixaSearchActions[] | undefined;
  showScannerIsReady?: boolean | undefined;
}

const SearchBarComponent: React.FC<SearchBarComponentProps> = ({
  onSearchBarClick,
  handleSearchQueryChange,
  onSearchQueryReset,
  searchQuery,
  autoFocus,
  onFocus,
  onBlur,
  actions,
}: SearchBarComponentProps) => {
  const { t } = useTranslation();
  return (
    <SearchBarComponentPresentation
      onClick={onSearchBarClick ?? (() => {})}
      onChange={handleSearchQueryChange ?? (() => {})}
      onClear={onSearchQueryReset ?? (() => {})}
      onFocus={onFocus ?? (() => {})}
      onBlur={onBlur ?? (() => {})}
      valueString={searchQuery ?? ""}
      translationsSearchString={t("searchBasicString")}
      autoFocus={autoFocus}
      actions={actions}
    />
  );
};

export default SearchBarComponent;
